import { LegalPage } from "@/components/LegalPage";
import { IubendaEmbed } from "@/components/IubendaEmbed";
import { useConsent } from "@/context/ConsentContext";

export default function Cookie() {
  const { reopen } = useConsent();
  return (
    <LegalPage title="Cookie Policy" hideNote>
      <IubendaEmbed url="https://www.iubenda.com/privacy-policy/14124580/cookie-policy" label="Cookie Policy" />
      <p className="mt-8">
        <button
          onClick={reopen}
          data-testid="reopen-consent"
          className="rounded-full bg-lavender px-6 py-3 text-sm font-medium text-white no-underline hover:bg-lavender-deep transition-colors"
        >
          Gestisci le preferenze cookie
        </button>
      </p>
    </LegalPage>
  );
}
